"use client";

import Link from "@casino/client/components/Link";
import { Button } from "@workspace/frontend-ui";

type Props = {
  label: string;
};

const ClaimWelcomeBonus: FC<Props> = ({ label }) => (
  <Link href="/profile/rewards">
    <Button variant="secondary">{label}</Button>
  </Link>
);

export default ClaimWelcomeBonus;
